var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('JobRenewContractProfileCard',{attrs:{"loading":_vm.loading},on:{"setLoading":function($event){_vm.loading = $event}}}),_c('OfferLinesCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }